<template>
    <div>
        <vue-good-table mode="remote" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: false
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <!-- <router-link :to="'/blast-list/detail?id=' + props.row.id">
                        <a class="btn btn-sm  btn-primary text-white margin5">Detail</a>
                    </router-link> -->

                    <div class="d-flex flex-column">
                    <!-- <a v-if="props.row.total_pending > 0" v-on:click="resendPending(props.row.blast_id)" class="btn btn-sm btn-warning text-white margin5">
                        <i class="fas fa-redo"></i> Resend Pending
                    </a> -->
                    <a v-if="props.row.total_pending > 0" v-on:click="resendPending(props.row.blast_id)" class="btn btn-sm btn-warning text-white margin5">
                        <i class="fas fa-redo"></i> Resend Pending
                    </a>
                    <a v-if="props.row.total_failed > 0" v-on:click="resendFailed(props.row.blast_id)" class="btn btn-sm btn-warning text-white margin5">
                        <i class="fas fa-redo"></i> Resend Gagal
                    </a>
                    <a v-if="props.row.total_pending > 0" v-on:click="stopBlast(props.row.blast_id)" class="btn btn-sm btn-danger text-white margin5">
                        <i class="fas fa-stop-circle"></i> Stop
                    </a>
                    </div>
<!--                     
                    <a v-on:click="deleteBlastList(props.row.id)" class="btn btn-sm  btn-danger text-white margin5">
                        Hapus
                    </a> -->
                </span>
                <span v-else-if="props.column.field == 'name'">
                    <strong>{{ props.row.name }}</strong>
                </span>
                <span v-else-if="props.column.field == 'text'">
                    {{ cutString(props.row.text) }}
                </span>
                <span v-else-if="props.column.field == 'status'">
                    <span v-if="props.row.total_pending > 0" class="badge badge-primary">Pengiriman Berjalan</span>
                    <span v-else class="badge badge-success">Pengiriman Selesai</span>
                </span>
                <span v-else-if="props.column.field == 'created_at'">
                    {{ convertDateToLocal(props.row.created_at) }}
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
        <div class="d-flex align-items-center justify-content-between mt-2">
            <div class="d-flex align-items-center">
                <label class="mr-2 mb-0">Per page</label>
                <select class="form-control form-control-sm w-auto" v-model.number="table.serverParams.limit" @change="onLimitChange">
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
            </div>
            <div class="d-flex align-items-center">
                <span class="text-muted small mr-3" v-if="table.rows && table.rows.length">Showing {{ table.rows.length }} items</span>
                <div class="btn-group" role="group" aria-label="Pagination controls">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        :disabled="cursorStack.length === 0 || table.isLoading"
                        @click="goPrevPage"
                        title="Go to previous page"
                        aria-label="Previous">
                        <i class="fas fa-chevron-left"></i>
                        <span class="d-none d-sm-inline"> Previous</span>
                    </button>
                    <button
                        class="btn btn-sm btn-outline-primary"
                        :disabled="!hasMore || table.isLoading"
                        @click="goNextPage"
                        title="Go to next page"
                        aria-label="Next">
                        <span class="d-none d-sm-inline">Next </span>
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="resendModal.show" class="modal fade show" tabindex="-1" role="dialog" style="display: block; background: rgba(0,0,0,0.4);">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Atur Ulang Jadwal Kirim Pending</h5>
                        <button type="button" class="close" aria-label="Close" @click="closeResendModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Tanggal Kirim</label>
                            <input type="date" class="form-control" v-model="resendModal.date" />
                        </div>
                        <div class="form-group">
                            <label>Jam Kirim</label>
                            <input type="time" class="form-control" v-model="resendModal.time" step="60" />
                        </div>
                        <small class="text-muted d-block">Gunakan fitur ini untuk mengirim ulang pesan dengan status "Menunggu Jadwal / Menunggu Device Terkoneksi"</small>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeResendModal">Batal</button>
                        <button type="button" class="btn btn-primary" @click="submitResendPending">Jadwalkan Ulang</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                table: {
                    isLoading: true,
                    columns: [{
                            label: "Name",
                            field: "name",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "10%",
                        },
                        {
                            label: "Text",
                            field: "text",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "20%",
                        },
                        {
                            label: "Total Pending",
                            field: "total_pending",
                            width: "10%",
                        },
                        {
                            label: "Total Sent",
                            field: "total_sent",
                            width: "10%",
                        },
                        {
                            label: "Total Failed",
                            field: "total_failed",
                            width: "10%",
                        },
                        {
                            label: "Status",
                            field: "status",
                            width: "10%",
                        },
                        {
                            label: "Action",
                            field: "action",
                            sortable: false,
                            width: "20%",
                        },
                    ],
                    rows: [],
                    serverParams: {
                        columnFilters: {},
                        sort: [{
                            field: "",
                            type: "",
                        }, ],
                        limit: 10,
                        last_id: null,
                    },
                },
                hasMore: false,
                cursorStack: [],
                resendModal: {
                    show: false,
                    blast_id: null,
                    date: "",
                    time: "",
                },
            };
        },
        mounted() {
            this.fn = () => {
                this.loadItems();
            }
            this.$root.$on("refresh_table", this.fn);
            this.loadItems();
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fn);
        },
        methods: {
            cutString(string){
                if(string == null || string == "") return ""
                
                if(string.length > 40){
                    string = string.slice(0, 40) + "..."
                }

                return string
            },
            convertDateToLocal(date) {
                return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
            },
            async stopBlast(blast_id) {
                if (confirm("Apakah Anda yakin ingin menghentikan pengiriman blast ini?")) {
                    try {
                        let response = await this.$store.dispatch("blast_list_stop", {
                            blast_id: blast_id
                        });
                        this.$toast.success(response.data.message);
                        this.loadItems();
                    } catch (err) {
                        this.$toast.error(err.response?.data?.message || 'Server error');
                    }
                }
            },
            openResendPendingModal(blast_id) {
                const now = moment().add(5, "minutes");
                this.resendModal = {
                    show: true,
                    blast_id,
                    date: now.format("YYYY-MM-DD"),
                    time: now.format("HH:mm"),
                };
            },
            closeResendModal() {
                this.resendModal.show = false;
            },
            async submitResendPending() {
                if (!this.resendModal.date || !this.resendModal.time) {
                    this.$toast.error("Tanggal dan jam wajib diisi");
                    return;
                }
                const startAt = moment(`${this.resendModal.date} ${this.resendModal.time}`, "YYYY-MM-DD HH:mm").valueOf();
                if (!startAt) {
                    this.$toast.error("Format tanggal atau jam tidak valid");
                    return;
                }
                try {
                    let response = await this.$store.dispatch("blast_list_resend_pending", {
                        blast_id: this.resendModal.blast_id,
                        start_at: startAt,
                    });
                    this.$toast.success(response.data.message);
                    this.loadItems();
                    this.closeResendModal();
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || 'Server error');
                }
            },
            async resendPending(blast_id) {
                this.openResendPendingModal(blast_id);
            },
            async resendFailed(blast_id) {
                if (confirm("Apakah Anda yakin ingin mengirim ulang pesan yang gagal?")) {
                    try {
                        let response = await this.$store.dispatch("blast_list_resend_failed", {
                            blast_id: blast_id
                        });
                        this.$toast.success(response.data.message);
                        this.loadItems();
                    } catch (err) {
                        this.$toast.error(err.response?.data?.message || 'Server error');
                    }
                }
            },
            // editBlastList(id) {
            //     this.$router.push('/blast-list/edit?id=' + id);
            // },
            updateParams(newProps) {
                this.table.serverParams = Object.assign({},
                    this.table.serverParams,
                    newProps
                );
            },
            onLimitChange() {
                this.updateParams({
                    limit: this.table.serverParams.limit,
                    last_id: null
                });
                this.cursorStack = [];
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.table.columns[params.columnIndex].field,
                    }, ],
                    last_id: null,
                });
                this.cursorStack = [];
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(Object.assign({}, params, { last_id: null }));
                this.cursorStack = [];
                this.loadItems();
            },
            goPrevPage() {
                if (this.cursorStack.length > 0) {
                    const prevCursor = this.cursorStack.pop();
                    this.updateParams({ last_id: prevCursor });
                    this.loadItems();
                }
            },
            goNextPage() {
                if (this.hasMore) {
                    // push current cursor before moving forward
                    this.cursorStack.push(this.table.serverParams.last_id);
                    const rows = this.table.rows || [];
                    const nextCursor = rows.length > 0 ? rows[rows.length - 1].id : null;
                    this.updateParams({ last_id: nextCursor });
                    this.loadItems();
                }
            },
            async loadItems() {
                this.table.isLoading = true
                try {
                    let response = await this.getFromServer(this.table.serverParams);
                    let blastLists = response.data.data.blast_lists;
                    this.table.rows = blastLists
                    this.hasMore = Array.isArray(blastLists) && blastLists.length === this.table.serverParams.limit
                } catch (err) {
                    console.log(err)
                    this.$toast.error("Too many request");
                }
                this.table.isLoading = false
            },
            async getFromServer(param) {
                // Build query for cursor-based pagination: limit & last_id
                const payload = {
                    limit: param.limit,
                };
                if (param.last_id) {
                    payload.last_id = param.last_id;
                }
                // Merge filters and sort if backend supports them alongside cursor
                if (param.columnFilters) {
                    payload.columnFilters = param.columnFilters;
                }
                if (param.sort && param.sort.length && param.sort[0].field) {
                    payload.sort = param.sort;
                }
                return await this.$store.dispatch("blast_list_all", payload);
            },
        },
    };
</script>

<style scoped>
    .margin5 {
        margin: 5px;
    }
</style>
